import React, { memo } from 'react';
import { Switch } from 'react-router-dom';

import { generateRoutes, GuardProps, rootRoutePaths, rootRoutes, RoutesDef, unauthenticatedRoutePaths, unauthenticatedRoutes } from '@/core/navigation';
import { LoginPage } from './pages/login';
import { LogoutPage } from './pages/logout';
import { VoucherRedeemPage } from './pages/voucher-redeem';
import { loggedOutGuard } from './services/logged-out.guard';
import { unauthenticatedGuard } from './services/unauthenticated.guard';
import { verifyGuard } from './services/verify.guard';
import { voucherRedeemGuard } from './services/voucher-redeem.guard';

const FEATURE_NAME = 'authentication';

const authenticationRoutesDef: RoutesDef<unauthenticatedRoutes> = {
  [unauthenticatedRoutes.LOGOUT]: {
    path: unauthenticatedRoutePaths[unauthenticatedRoutes.LOGOUT],
    guard: loggedOutGuard,
    component: LogoutPage,
  },
  [unauthenticatedRoutes.VERIFY]: {
    path: unauthenticatedRoutePaths[unauthenticatedRoutes.VERIFY],
    guard: verifyGuard,
    component: LogoutPage,
  },
  [unauthenticatedRoutes.VOUCHER_REDEEM_LANDING]: {
    path: unauthenticatedRoutePaths[unauthenticatedRoutes.VOUCHER_REDEEM_LANDING],
    guard: voucherRedeemGuard,
    component: VoucherRedeemPage,
  },
  [unauthenticatedRoutes.LOGIN]: {
    path: unauthenticatedRoutePaths[unauthenticatedRoutes.LOGIN],
    guard: unauthenticatedGuard,
    component: LoginPage,
  },
};

const routes = generateRoutes(authenticationRoutesDef, FEATURE_NAME, rootRoutePaths[rootRoutes.UNAUTHENTICATED]);
export default memo<GuardProps>(() => <Switch>{routes}</Switch>);
